import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "add-wrapper" }

import { useThemeColor, useThemeColorWithAlpha } from '@/utils/theme'
import { useRouter } from 'vue-router'
import { ref } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'AddBtn',
  props: {
  publishType: String,
  boardId: String,
  isAPublishPost: Number,
  isEnablePShare: Number
},
  setup(__props) {

_useCssVars(_ctx => ({
  "v64873704": (_unref(themeColor)),
  "v7e48855a": (_unref(themeColorWithAlpha))
}))

const themeColor = useThemeColor()
const themeColorWithAlpha = useThemeColorWithAlpha(0.33)
const router = useRouter()

const props = __props

const type = ref<string>(props.publishType as string | 'community')

const jumpHandle = () => {
  if (type.value === 'shortVideo') {
    router.push({ path: '/publishVideo', query: { boardId: props.boardId } })
  } else {
    router.push({
      path: '/communityPublish',
      query: { boardId: props.boardId, isAPublishPost: props.isAPublishPost, isEnablePShare: props.isEnablePShare }
    })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "add-btn",
      onClick: jumpHandle
    }, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("i", { class: "iconfont icon-icon_shequzhongxin_xinzeng" }, null, -1)
    ]))])
  ]))
}
}

})